import { useIsAuthenticated } from '@heidi/auth/state';
import { useQuery } from '@tanstack/react-query';
import {
  GET_ORGANIZATION_TEMPLATES_FILTERS_METADATA,
  type TemplateSearchFilterMetadataResponse,
} from '../../contracts';
import { getOrganizationTemplatesMetadata } from '../api/templates';

export function useQueryOrganizationTemplatesFiltersMetadata<
  T = TemplateSearchFilterMetadataResponse,
>(
  organizationId: string,
  select?: (data: TemplateSearchFilterMetadataResponse) => T,
  /** Caller-supplied user gate. Authentication is read here. */
  isEnabled = true
) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQuery({
    queryKey: [
      GET_ORGANIZATION_TEMPLATES_FILTERS_METADATA,
      { organizationId: organizationId },
    ],
    retry: 3,
    enabled: isAuthenticated && isEnabled && Boolean(organizationId),
    queryFn: async () => {
      const { data } = await getOrganizationTemplatesMetadata(organizationId);
      return data;
    },
    select,
  });
}
